export {ShortcutComponent} from '@shared/layout/shortcut/shortcut.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/shortcut/index.ts